import { Chip, Grid2 } from "@mui/material";
import { forwardRef, useEffect, useImperativeHandle, useState } from "react";

const AvailableSlots = forwardRef(({dateTimeSlots, setTimeSlot, disabled, hideDates }, ref) => {

    const [selectedSlot, setSelectedSlot] = useState();

    const clearSelectedSlot = () => {
        setSelectedSlot();
    }

    useImperativeHandle(ref, () => ({
      clearSelectedSlot
        }));

    const onTimeSlotClick = (slot) => {
        setSelectedSlot(slot);
        setTimeSlot(slot);
    }

    return (
      <div className="container mt-2 g-0">
        {dateTimeSlots?.length > 0 ? (
            dateTimeSlots?.map((d) => (
        <div class="row g-0">
          {!hideDates && (<div className="col-12 d-flex justify-content-start border-top">
            <label className="ms-1">{new Date(d.key).toLocaleString("en-US", {day:"numeric", month:"short", year:"numeric", weekday:"short"})}
            </label>
            </div>)}
        
        <Grid2 container size={12}>
          {d?.value?.length > 0 ? (
            d.value?.map((slot, index) => (
              <Chip 
              label={(new Date(slot)).toLocaleString("en-US", {hour:"2-digit", minute:"2-digit"})}
              clickable
              color={selectedSlot === slot ? "secondary":"primary"}
              sx={{margin:"2px"}}
              disabled = {disabled}
              onClick={() => onTimeSlotClick(slot)}
              ></Chip>
            ))
          ) : (
            <div className="text-center">
              <p className="text-muted">No slots available.</p>
            </div>
          )}
        </Grid2>
        </div>
            ))):(<></>)}
        
      </div>
    );
  });
  
  export default AvailableSlots;